import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useInjection } from '../../../di_container/InjectionProvider';
import { Payment } from '../../firestore_model';
import { useClinicUser } from '..';
import { Utils } from '../../../common/helper';
import { pagination } from '../../../common/constants/Constants';
export const usePayment = () => {
    const columns = [
        { id: 'content', label: '業務内容', minWidth: 150 },
        { id: 'worker', label: 'ワーカー', minWidth: 80 },
        { id: 'date', label: '日付', minWidth: 80 },
        { id: 'reward', label: '報酬', minWidth: 60 },
        {
            id: 'paidReward',
            label: '実際の支払額',
            minWidth: 60,
        },
        { id: 'paymentsType', label: '支払方法', minWidth: 70 },
        { id: 'paymentButton', label: '', minWidth: 100, align: 'right' },
    ];
    const { container } = useInjection();
    const { t } = useTranslation();
    const { paymentClinic } = useClinicUser();
    const [loadingPaymentList, setLoadingPaymentList] = useState(false);
    const [loadingPayReward, setLoadingPayReward] = useState(false);
    const loadPaymentList = useCallback(async (lastDocument) => {
        setLoadingPaymentList(true);
        try {
            if (Utils.isNull(paymentClinic)) {
                throw new Error(t('システムエラー'));
            }
            const firestoreRepository = container.resolve('FirestoreRepository');
            const result = await firestoreRepository.loadDocuments({
                path: paymentClinic.jobRewards.collectionReference.path,
                isGroup: false,
                limit: pagination.limit,
                startAfter: lastDocument,
                orderBy: {
                    fieldPath: 'createdAt',
                    directionStr: 'desc',
                },
            });
            setLoadingPaymentList(false);
            return {
                data: result.docs.map((item) => Payment.JobReward.fromSnapshot(item)),
                lastDocument: result.lastDocument,
            };
        }
        catch (e) {
            setLoadingPaymentList(false);
            throw e;
        }
    }, [paymentClinic]);
    const loadWithholdingAmount = useCallback((amount) => {
        const taxRepository = container.resolve('TaxRepository');
        return taxRepository.loadWithholdingAmount(amount);
    }, [container]);
    const payRewardToWorker = useCallback(async (rewardId, amount) => {
        setLoadingPayReward(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            await imoryApiRepository.payRewardToWorker(rewardId, amount);
            setLoadingPayReward(false);
        }
        catch (e) {
            setLoadingPayReward(false);
            throw e;
        }
    }, []);
    return { columns, loadPaymentList, loadingPaymentList, loadWithholdingAmount, payRewardToWorker, loadingPayReward };
};
